export default {
  name: 'BaseQuery',

  inheritAttrs: false,

  created () {
    this.$on('addField', field => {
      if (field) {
        this.fields.push(field)
      }
    })
    this.$on('removeField', field => {
      if (field) {
        this.fields.splice(this.fields.indexOf(field), 1)
      }
    })
  },

  data () {
    return {
      fields: []
    }
  },

  methods: {
    confirm () {
      const { search, model, pageKey = 'page', resetPage = true } = this.$attrs
      if (search) {
        const hasPage = model.hasOwnProperty(pageKey)
        if (hasPage && resetPage) {
          model[pageKey] = 1
        }
        search(model)
      }
    },
    reset () {
      this.fields.forEach(field => field.resetField())
      this.$nextTick(() => {
        this.$emit('reset')
        this.confirm()
      })
    }
  },

  render (h) {
    const { model, inline = true, options, ...attrs } = this.$attrs
    const { default: defaultSlots = [] } = this.$slots
    const children = Array.isArray(options)
      ? options.map(({ prop, render }) => <el-form-item prop={prop}>{ render.call(this, h, this.confirm) }</el-form-item>)
      : defaultSlots.map(child => {
        return <el-form-item prop={child.data.attrs.prop}>{ child }</el-form-item>
      })
    const buttonGroup = <el-form-item>
      <el-button type="primary" plain onClick={ this.confirm }>确定</el-button>
      <el-button type="default" plain onClick={ this.reset }>重置</el-button>
    </el-form-item>
    return h('el-form', { props: { inline, model, ...attrs, on: this.$listeners } }, [ ...children, buttonGroup ])
  }
}
